// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ac5fAq43TtgVn8La3jei{flex-direction:column;gap:8px;padding:0 24px 16px;display:flex}.EcoEITPy5cT3SIIeE38r{justify-content:flex-end;gap:8px;padding:16px 24px 24px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `Ac5fAq43TtgVn8La3jei`,
	"actions": `EcoEITPy5cT3SIIeE38r`
};
export default ___CSS_LOADER_EXPORT___;
